import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import store from '@/store'

import { oldBackAxios, notifierAPI } from "@/network/network";
import {SocketData} from './index.d';
import quiz_service from '@/modules/Quiz/index'

// @ts-ignore
import qs from 'qs'
import ReconnectingWebSocket from "reconnecting-websocket";

@Module({
  namespaced: true,
  name: 'notifications',
  store,
  dynamic: true
})
class Notifications extends VuexModule {
  socket: any
  fast_notifications: any = [
  ]
  notifications: any =  []
  last_notification: any = null
  is_registered: boolean = false
  token: string = ''
  fingerPrint: string = ''
  notif_timeouts: any = {
  }

  @Mutation
  setListNotification(list: Array<any>) {
    if (this.notifications && this.notifications.length > 0) {
      this.notifications.push(...list)
    } else {
      this.notifications = list
    }
  }
  @Mutation
  destroyNotification() {
    this.notifications = []
  }
  @Action({ rawError: true, commit: 'setListNotification' })
  async getNotifications(page: number) {
    let request = {
      "pageNumber": page,
      "pageSize": 20,
      "includeCount": true,
      "sortFields": [
        {
          "field": "string",
          "order": 1
        }
      ],
      "appIdFilter": "net.rixtrema.lexe,net.rixtrema.crm",
      // "appIdFilter": "string",
      // "typeFilter": "string",
      // "excludeHiddenFilter": true,
      // "date": "2021-04-13T08:16:36.635Z"
    }
    
    try {
      const response = await notifierAPI.post('Event/webSocketsList', request)
      console.log('response.data', response.data)
      if (response.data.records) {
        return Promise.resolve(response.data.records)
      }
    } catch (err) {
      return Promise.reject(err.response.data.errors)
    }
  }

  @Mutation
  async setFastMessage(notification: any) {
    console.log('notification', typeof notification, notification)
    if (notification && typeof notification === 'string') {
      let _notif = JSON.parse(notification)
      if (_notif.body) {
        let id = await quiz_service.uuidv4();
        _notif.id = id
        this.last_notification = _notif
        this.fast_notifications.push(_notif)

        if (this.notifications.length > 0) {
          this.notifications.unshift(_notif)
        }

        if (this.fast_notifications.length >= 3){
          this.fast_notifications = this.fast_notifications.slice(-3);
        }

        this.notif_timeouts[id] = setTimeout(() => {
          this.fast_notifications = this.fast_notifications.filter((item: any) => {
            return item.id != id
          })
        }, 20000);
      }
    }
  }

  @Action({ rawError: true, commit: 'setFastMessage' })
  async initSocket(socketData: SocketData) {

    const {token, fingerPrint} = socketData;

    console.log('socketdata', socketData);

    this.setData({token, fingerPrint})

    let msg = {
      action : 'register',
      // system : 'Larkspur',
      // login,
      // platform : "CRM",
      token,
      fingerPrint
    }

    let url: any = 'wss://ws.rixtrema.net:443'
    this.socket = new ReconnectingWebSocket(url);
  
    await this.socket.send(JSON.stringify(msg))    
  }

  @Mutation
  setData(data: {token: string, fingerPrint: string}){
    
    const {token, fingerPrint} = data;
    this.token = token;
    this.fingerPrint = fingerPrint;
    
  }
  
  @Mutation
  removeReadEvent(ids: Array<string>) {
    this.fast_notifications = this.fast_notifications.filter((item: any) => !ids.includes(item.id))
  }

  @Mutation
  clearNotifTimeout(id: string) {
    clearTimeout(this.notif_timeouts[id])
  }

  @Action({ rawError: true, commit: 'removeReadEvent' })
  async readEvent(id: Array<string>) {
    let request = {
      event: [id],
      system: 'Larkspur',
      token: this.token,
      fingerPrint: this.fingerPrint
    }

    try {
      const response = await oldBackAxios.post('https://rixtrema.net:8889/read', qs.stringify(request))
      if (response.data.statusCode === 200) {
        return Promise.resolve(id)
      }
    } catch (err) {
      return Promise.reject(err.response.data.errors)
    }
  }

  @Mutation
  setReadEvents(ids: Array<string>) {
    this.notifications.forEach((item: any) => {
      if (ids.includes(item.id)) {
        item.read = '1'
      }
    })
  }
  @Action({ rawError: true, commit: 'setReadEvents' })
  async readEvents(ids: Array<Number>) {
    let request = {
      event: `[${ids.join(',')}]`,
      system: 'Larkspur',
      token: this.token,
      fingerPrint: this.fingerPrint
    }

    try {
      const response = await oldBackAxios.post('https://rixtrema.net:8889/read', qs.stringify(request))
      if (response.data.statusCode === 200) {
        return Promise.resolve(ids)
      }
    } catch (err) {
      return Promise.reject(err.response.data.errors)
    }
  }
}

export default getModule(Notifications)
